"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddConvictionsToDriverCommand = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var AddConvictionsToDriverCommand = /** @class */ (function (_super) {
    __extends(AddConvictionsToDriverCommand, _super);
    function AddConvictionsToDriverCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddConvictionsToDriverCommand.prototype.exec = function (props) {
        var _a;
        var index = this.getSetting("index", props.journeyEventDefinition.settings);
        var isHasConvictionQuestion = (_a = this.getSetting("isHasConvictionQuestion", props.journeyEventDefinition.settings)) !== null && _a !== void 0 ? _a : false;
        var parentObject = index === undefined ? props.interaction.policyHolder : props.interaction.additionalDrivers[index];
        var parentObjectString = index === undefined ? "policyHolder" : "additionalDrivers[".concat(index, "]");
        var convictions = [];
        if ((parentObject.hasConvictions === true || parentObject.hasConvictions === "true") && isHasConvictionQuestion) {
            convictions = [{}];
        }
        else if (!isHasConvictionQuestion) {
            convictions = __spreadArray(__spreadArray([], parentObject.convictions, true), [
                {}
            ], false);
        }
        if (!parentObject.hasConvictions) {
            convictions = [];
        }
        props.updateInteraction(convictions, "".concat(parentObjectString, ".convictions"));
        props.updateInteraction(convictions.length, "".concat(parentObjectString, ".numberOfConvictions"));
        return Promise.resolve({});
    };
    return AddConvictionsToDriverCommand;
}(plugin_journey_1.JourneyCommandBase));
exports.AddConvictionsToDriverCommand = AddConvictionsToDriverCommand;
//# sourceMappingURL=AddConvictionsToDriverCommand.js.map